import { Loader, Save, X } from "lucide-react";
import React, { useRef, useState } from "react";
import Spacing from "../Spacing";
import { notify } from "../../helpers";
import { addFeatureConfig } from "../../services/users";
import { Drawer } from 'vaul';

export default function AddFeatureModal({
  account_id,
  addNewFeature = false,
  setAddNewFeature = () => {},
  autoLoadData = () => {},
  previousScrollPosition = 0
}) {

  const [enableLoader, setEnableLoader] = useState(false);
  const defaultValues = {
    name: "",
    value: true,
  }

  const [formData, setFormData] = useState(defaultValues);
  const dropdownRef = useRef(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: name === "value" ? value === "true" : value
    });
  };

  const handleAddFeatureConfig = async (e) => {
    try {
      e.preventDefault();

      if (!formData.name.trim()) {
        notify("error", "Name can't be empty", 2);
        return;
      }

      setEnableLoader(true);
      e.target.disabled = true;

      const response = await addFeatureConfig(account_id,formData);

      if (response.detail) {
        notify('error', response.detail, 2);
      } else { 
        if(response.data.status === 'success'){
          notify("success", response?.data?.message, 2);
          setFormData(defaultValues);
          handleDrawerClose();
          autoLoadData();
        } else {
          notify("error", response?.data?.message, 2);
        }
      }

      setEnableLoader(false);
      e.target.disabled = false;
    } catch (error) {
      setEnableLoader(false);
      if (error?.response && error?.response?.data && error?.response?.data?.detail) {
        notify("error", error?.response?.data?.detail, 2);
      }
    }
  };

  const handleDrawerClose = () => {
    setAddNewFeature(false);
    window.scrollTo(0, previousScrollPosition);
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={addNewFeature} onOpenChange={handleDrawerClose}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4">
            <Drawer.Title className="sr-only">Add Feature</Drawer.Title>
            <Drawer.Description className="sr-only">Add New Feature</Drawer.Description>
            <div className="docpro_modal_wrap docpro_style_auto">
              <div className="docpro_modal">
                <button
                  className="docpro_close_btn"
                  onClick={() => handleDrawerClose()}
                >
                  <X />
                </button>
                <h2 className="docpro_fs_24">Add New Feature</h2>

                <form onSubmit={handleAddFeatureConfig}>
                  <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_1">
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Identifier Name <span className="docpro_red_color">*</span> <small className="docpro_accent_color">(Only use letter and underscore)</small>
                      </label>
                      <input
                        type="text"
                        name="name"
                        className="docpro_form_field size_lg"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        placeholder="example_feature_name"
                      />
                    </div>
                    <div className="docpro_grid_item">
                      <label className="docpro_fw_500 docpro_primary_color">
                        Enable <span className="docpro_red_color">*</span>
                      </label>
                      <div className="docpro_radio_group" style={{ margin: '10px 0 0 20px' }}>
                        <div className="docpro_radio">
                          <input
                            type="radio"
                            name="value"
                            onChange={handleChange}
                            defaultChecked={formData.value === true}
                            value={true}
                            required
                          />
                          <label style={{ paddingLeft: "30px" }}>Yes</label>
                        </div>
                        <div className="docpro_radio">
                          <input
                            type="radio"
                            name="value"
                            onChange={handleChange}
                            defaultChecked={formData.value === false}
                            value={false}
                            required
                          />
                          <label style={{ paddingLeft: "30px" }}>No</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Spacing lg="32" sm="32" />
                  <div className="docpro_modal_btns">
                    <button
                      type="submit"
                      className="docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg"
                      style={{ minWidth: "140px" }}
                      disabled={enableLoader ? true : false}
                    >
                      <Save width={20} height={20} />
                      Submit
                    </button>
                  </div>
                </form>

                {enableLoader && (
                  <div className="absolute top-0 left-0 w-full" style={{ height: '100%', zIndex: 3 }}>
                    <div className="flex items-center loading" style={{ width: '100%', height: '100%', justifyContent: 'center', background: 'rgb(255 255 255 / 63%)', borderRadius: '10px' }}>
                      <span className="docpro_loading" style={{ position: 'inherit' }}>
                        <Loader width={46} height={46} style={{ color: 'var(--accent)' }} />
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
